<div class="content-container">
  <div class="title d-inline-flex justify-content-between w-100">
    <mwp-text-translate text="PROFILE INFO" jsonKey="profileInfo" />
    @if (isPopupButtonsEnabled) {
      <div class="d-inline-flex mb-1">
        <button class="mwp-button w-100 me-3 text-nowrap" (click)="openUpdateRegisteredEmail()">
          <mwp-text-translate text="Update Registered Email" jsonKey="updateRegistedEmail" />
        </button>
        <button class="mwp-button w-100 text-nowrap" (click)="openUpdatePasswordDialog()">
          <mwp-text-translate text="Change Password" jsonKey="changePassword" />
        </button>
      </div>
    }
  </div>
  <div class="content pe-0">
    <form [formGroup]="profileForm" autocomplete="off">
      <div class="d-flex flex-wrap">
        @if (member.showNumber) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="SID" nameForControl="number" />
        </div>
        }
        @if (member.showERID) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="ERID" nameForControl="erid" />
        </div>
        }
        @if (member.showEnrollmentUID) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Registered Email" nameForControl="enrollmentUID" />
        </div>
        }
        @if (member.showName) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Name" nameForControl="name" />
        </div>
        }
        @if (member.showDOBDecrypted) {
        <div class="w-20 pe-3 mb-4">
          <mwp-datepicker [form]="profileForm" labelName="Date Of Birth" nameForControl="dobDecrypted" />
        </div>
        }
        @if (member.showSSNDecrypted) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="SSN" nameForControl="ssnDecrypted" />
        </div>
        }
        @if (member.showHomeEmail) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Home Email" nameForControl="homeEmail" />
        </div>
        }
        @if (member.showHomePhone) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Home Phone" [maskType]="maskType.phone" nameForControl="homePhone" />
        </div>
        }
        @if (member.showCellPhone) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Cell Phone" [maskType]="maskType.phone" nameForControl="cellPhone" />
        </div>
        }
        @if (member.showAddress) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Address 1" nameForControl="homeAddressLine1" />
        </div>
        }
        @if (member.showAddress) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Address 2" nameForControl="homeAddressLine2" />
        </div>
        }
        @if (member.showHomeCity) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="City" nameForControl="homeCity" />
        </div>
        }
        @if (member.showHomeState) {
        <div class="w-20 pe-3 mb-4">
          <mwp-dropdown-enum [form]="profileForm" labelName="Home State" nameForControl="homeState" [dataEnum]="usStates" />
        </div>
        }
        @if (member.showHomeZipCode) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Zip Code" [maskType]="maskType.zipCode" nameForControl="homeZipCode" />
        </div>
        }
        @if (member.showGender) {
        <div class="w-20 pe-3 mb-4">
          <mwp-dropdown-enum [form]="profileForm" labelName="Gender" nameForControl="gender" [dataEnum]="genders" />
        </div>
        }
        @if (member.showDateOfHire) {
        <div class="w-20 pe-3 mb-4">
          <mwp-datepicker [form]="profileForm" labelName="Date of Hire" nameForControl="dateOfHire" />
        </div>
        }
        @if (member.showWorkJobTitle) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Job Title" nameForControl="workJobTitle" />
        </div>
        }
        @if (member.showWorkHours) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" labelName="Work Hours" nameForControl="workHours" />
        </div>
        }
        @if (member.showCompanyLocation) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.companyLocationCaption" nameForControl="companyLocation" />
        </div>
        }
        @if (member.showDivision) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayDivisionCaption" nameForControl="displayDivision" />
        </div>
        }
        @if (member.showEEClass1) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayEEClass1Caption" nameForControl="displayEEClass1" />
        </div>
        }
        @if (member.showEEClass2) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayEEClass2Caption" nameForControl="displayEEClass2" />
        </div>
        }
        @if (member.showEEClass3) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayEEClass3Caption" nameForControl="displayEEClass3" />
        </div>
        }
        @if (member.showEEClass4) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayEEClass4Caption" nameForControl="displayEEClass4" />
        </div>
        }
        @if (member.showEEClass5) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayEEClass5Caption" nameForControl="displayEEClass5" />
        </div>
        }
        @if (member.showDepartment) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.departmentCaption" nameForControl="department" />
        </div>
        }
        @if (member.showPosition) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.positionCaption" nameForControl="position" />
        </div>
        }
        @if (member.showEmploymentStatus) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.employmentStatusCaption" nameForControl="employmentStatus" />
        </div>
        }
        @if (member.showUdf1) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayUDF1Caption" nameForControl="displayUDF1" />
        </div>
        }
        @if (member.showUdf2) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayUDF2Caption" nameForControl="displayUDF2" />
        </div>
        }
        @if (member.showUdf3) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayUDF3Caption" nameForControl="displayUDF3" />
        </div>
        }
        @if (member.showUdf4) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayUDF4Caption" nameForControl="displayUDF4" />
        </div>
        }
        @if (member.showUdf5) {
        <div class="w-20 pe-3 mb-4">
          <mwp-input [form]="profileForm" [labelName]="member.displayUDF5Caption" nameForControl="displayUDF5" />
        </div>
        }
      </div>
    </form>
  </div>
  <div class="footer">
    <div class="d-inline-flex w-100 justify-content-end">
      @if (displayContinueButton) {
      <button class="mwp-button" [disabled]="!profileForm.valid && !profileForm.pristine " (click)="submitForm()">
        <mwp-text-translate text="Continue" jsonKey="continue" />
      </button>
      }
      @if (!displayContinueButton) {
      <button class="mwp-button-delete mx-3" (click)="deleteAccount()">
        <mwp-text-translate text="Delete Account" jsonKey="deleteAccount" />
      </button>
      <button class="mwp-button-save" [disabled]="!profileForm.valid" (click)="submitForm()">
        <mwp-text-translate text="Save" jsonKey="save" />
      </button>
      }
    </div>
  </div>
</div>